<template>
  <div class="flex act-container">
    <div>
      <act-preview
        navigationBg="#F72727"
        phoneHeaderFixedColor="#fff"
        navigationTitle="口令红包"
      >
        <img
          :src="ruleForm.gameBgp"
          style="width: 375px; height: 667px"
          v-if="ruleForm.gameBgp"
        />
      </act-preview>
    </div>
    <div class="add-goods-containers">
      <div class="act-step-wrapper">
        <hm-step
          :steps="steps"
          :scroll="true"
          :step="currentStep"
          @scroll="windowScroll"
        ></hm-step>
      </div>
      <div class="act-wrapper">
        <el-scrollbar :style="{ height: scrollHeight + 'px' }">
          <div class="pvw flex flex-wrap">
            <div class="flex-4">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="170px"
              >
                <div id="base">1.基本信息</div>
                <el-form-item label="活动标题" prop="gameName">
                  <el-input
                    maxlength="25"
                    style="width: 400px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.gameName"
                    placeholder="请输入活动标题"
                    :disabled="queryTypeDisabled"
                  ></el-input>
                </el-form-item>
                <el-form-item label="活动时间" prop="activityDate">
                  <el-date-picker
                    :default-time="['00:00:00', '23:59:59']"
                    v-model="ruleForm.activityDate"
                    :picker-options="pickerOptions"
                    type="datetimerange"
                    align="right"
                    start-placeholder="活动开始时间"
                    end-placeholder="活动结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="small"
                    class="mr10"
                    :disabled="queryTypeDisabled && queryTypeDisabledEidt"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="主图：" prop="mainImgUrl">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccess"
                    @crop-upload-fail="cropUploadFail"
                    v-model="show"
                    v-if="show"
                    noCircle
                    noSquare
                    :width="750"
                    :height="1334"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>
                  <el-button
                    type="primary"
                    size="small"
                    v-show="!ruleForm.gameBgp"
                    @click="toggleShow"
                    >上传</el-button
                  >
                  <span class="form-tip"
                    >图片尺寸建议750x1334（最多上传一张）</span
                  >
                  <div class="priview" v-if="ruleForm.gameBgp">
                    <img :src="ruleForm.gameBgp" alt="主图" />
                    <div class="opreat-wrapper flex item-center flex-center">
                      <el-button type="text" @click="handleRemove" v-if="!queryTypeDisabled"
                        >删除</el-button
                      >
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="活动规则说明" prop="gameRuleRemark">
                  <hm-rich-editor
                    v-model="ruleForm.gameRuleRemark"
                    :html="ruleForm.gameRuleRemark"
                    :disabled="queryTypeDisabled"
                  />
                </el-form-item>

                <div class="mt40" id="gameRule">
                  {{ steps.length === 3 ? 2 : 2 }}活动规则
                </div>

                <el-form-item label="口令:" prop="password">
                  <el-input
                    maxlength="25"
                    style="width: 400px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.password"
                    placeholder="请输入口令"
                    :disabled="queryTypeDisabled"
                  ></el-input>
                  <el-button
                    type="primary"
                    @click="addPassword"
                    size="mini"
                    icon="hmicon icon-hao"
                    circle
                    :disabled="queryTypeDisabled"
                  ></el-button>
                  <div v-if="ruleForm.wordArr.length > 0">
                    <div>已输入口令</div>
                    <div class="timeList">
                      <div
                        class="timeListItem mb10"
                        v-for="(item, index) in ruleForm.wordArr"
                        :key="index"
                      >
                        <div>
                          <span class="text mr10">{{ item }}</span>
                          <el-button
                            type="warning"
                            @click="deletePassword(index)"
                            class="ml10"
                            size="mini"
                            icon="hmicon icon-jianhao"
                            circle
                            :disabled="queryTypeDisabled"
                          ></el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="" prop="drawTypeList">
                  <div class="flex batch flex-between item-center">
                    <div>
                      <el-button
                        size="small"
                        type="primary"
                        @click="batchSetting"
                        :disabled="queryTypeDisabled"
                        >添加奖励
                      </el-button>
                    </div>
                  </div>
                  <el-table
                    :data="ruleForm.passwordRuleModel.prizeList"
                    row-key="wxshopSkuId"
                    border
                    class="mt10"
                    stripe
                    max-height="400"
                    style="width: 100%"
                    :header-cell-style="{
                      background: '#f7f7f7',
                      color: '#606266',
                    }"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      type="index"
                      label="序号"
                      width="50"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="口令红包奖励"
                    >
                      <template slot-scope="scope">
                        <el-form-item>
                          <!-- :disabled="queryTypeDisabled" -->
                          <el-select
                            v-model="scope.row.couponSendId"
                            size="small"
                            style="width: 160px"
                            placeholder="请选择口令红包奖励"
                            @change="couponListChange(scope.row)"
                            :disabled="queryTypeDisabled"
                          >
                            <el-option
                              :label="coupon.name"
                              :value="coupon.couponSendId"
                              v-for="(coupon, couponIndex) in couponList"
                              :key="couponIndex"
                            ></el-option>
                            <el-option :label="prize.couponSendName" :value="prize.couponSendId" v-for="(prize, prizeIndex) in ruleForm.passwordRuleModel.prizeList" :key="prizeIndex" v-show="scope.row.isEdit" ></el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="数量"
                      width="300px"
                    >
                      <template slot-scope="scope">
                        <el-form-item>
                          <el-input
                            placeholder="请输入数量"
                            size="small"
                            :maxlength="5"
                            v-model="scope.row.sendNum"
                            :disabled="queryTypeDisabled"
                          ></el-input>
                          <div class="limit" v-if="scope.row.sendNumLimite">
                            <span class="primary">
                              数量不得大于{{ scope.row.sendNumLimite }}
                            </span>
                          </div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="操作"
                      width="80px"
                    >
                      <template slot-scope="scope">
                        <el-button
                          @click="deleteAppend(scope.$index)"
                          circle
                          type="warning"
                          size="mini"
                          icon="hmicon icon-jianhao"
                          :disabled="queryTypeDisabled"
                        >
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>

                <el-form-item label="参与限制" prop="joinLimitMode">
                  <template>
                    <div>
                      <el-radio label="total" v-model="ruleForm.joinLimitMode" :disabled="queryTypeDisabled">
                        <span>总参与次数限制，活动时间内，单人最多可参</span>
                        <el-input
                          type="number"
                          @mousewheel.prevent.native
                          :disabled="ruleForm.joinLimitMode !== 'total' || queryTypeDisabled"
                          style="width: 100px"
                          size="small"
                          clearable
                          class="mr10 ipt"
                          v-model.trim="ruleForm.joinNum"
                          placeholder="请输入数字"
                        ></el-input>
                        <span>次</span>
                      </el-radio>
                    </div>
                    <div>
                      <el-radio label="day" v-model="ruleForm.joinLimitMode" :disabled="queryTypeDisabled">
                        <span>每日参与次数限制，单人每日最多可参与</span>
                        <el-input
                          type="number"
                          @mousewheel.prevent.native
                          :disabled="ruleForm.joinLimitMode !== 'day' || queryTypeDisabled"
                          style="width: 100px"
                          size="small"
                          clearable
                          class="mr10 ipt"
                          v-model.trim="ruleForm.joinNum2"
                          placeholder="请输入数字"
                        ></el-input>
                        <span>次</span>
                      </el-radio>
                    </div>
                    <div class="form-tip">
                      <!-- 提示 -->
                    </div>
                  </template>
                </el-form-item>

                <div class="flex flex-center">
                  <el-button
                    type="primary"
                    size="small"
                    @click="submitEditForm('ruleForm')"
                    v-if="!queryTypeDisabledEidt"
                    >确定
                  </el-button>
                  <el-button size="small" @click="$router.back(-1)"
                    >返回
                  </el-button>
                </div>
              </el-form>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import { arrayUnique2 } from "@/utils/utils";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";

import XLSX from "xlsx";
import HmFilterMSGoods from "@/components/HmFilterMSGoods";

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor,
    HmFilterMSGoods,
    actPreview,
  },
  data() {
    const patterndLaunchTimeTypeFunc = function (rule, val, callback) {
      let flag = true;
      if (this.ruleForm.launchTimeType == "custom") {
        if (!this.ruleForm.customTimeNum) {
          flag = false;
        }
      }
      if (flag) {
        callback();
      } else {
        return callback(new Error("请输入自定义时长时间"));
      }
    }.bind(this);
    const patterndDrawTypeListFunc = function (rule, val, callback) {
      let flag = true;
      callback();
    }.bind(this);
    const patterndCouponListFunc = function (rule, val, callback) {
      let flag = true;
      callback();
    }.bind(this);
    const actDate = function (rule, val, callback) {
      // if (val > +this.ruleForm.actMemberUpperLimit) {
      //   return callback(new Error("已报名人数不能大于活动人数上限"));
      // }
      if (!this.ruleForm.activityDate.length > 0) {
        return callback(new Error("请选择活动时间段"));
      }

      callback();
    }.bind(this);
    const patterndMainImgUrlFunc = function (rule, val, callback) {
      if (!this.ruleForm.gameBgp) {
        return callback(new Error("请选择主图"));
      }
      callback();
    }.bind(this);
    const wordArrFunc = function (rule, val, callback) {
      //   if (this.ruleForm.wordArr.length===0) {
      //     return callback(new Error("请输入口令"));
      //   }
      callback();
    }.bind(this);
    const patterndRawTypeFunc = function (rule, val, callback) {
      if (this.ruleForm.joinLimitMode === "total") {
        if (this.ruleForm.joinNum) {
          callback();
        } else {
          return callback(new Error("请填写参与限制次数"));
        }
      } else {
        if (this.ruleForm.joinNum2) {
          callback();
        } else {
          return callback(new Error("请填写参与限制次数"));
        }
      }
      callback();
    }.bind(this);
    return {
      passwordList: [],
      suoyin: "",
      linshi: [],
      currentVirtualPage: 1,
      pageVirtualSize: 10,
      searchDialogCondition: {},
      selectGoodsWindow: false,
      showGoodsSn: true,
      selectOther: false,
      selectAll: false,
      expressList: [],
      errValidGoods: false,
      errInputResult: [],
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        },
      },
      endTime: "2019-11-11 18:12:00",
      isRadio: false,

      storeId: "",
      currentStep: 1,
      scrollHeight: 0,
      show: false,
      dialogVisible: false,
      steps: [
        {
          id: "base",
          name: "基本信息",
        },
        {
          id: "gameRule",
          name: "活动规则",
        },
      ],
      ruleForm: {
        gameBgp: "",
        gameType: "password",
        couponSendId: "",
        gameStartTime: "",
        gameEndTime: "",
        activityDate: [],
        gameName: "",
        gameRuleRemark: "",
        gameShareContent: "",
        gameBgm: "",
        password: "",
        wordArr: [],
        joinLimitMode: "",
        joinNum: "",
        joinNum2: "",
        passwordRuleModel: {
          wordArr: [],
          joinLimitMode: "",
          joinNum: "",
          prizeList: [],
        },
        saveMoneyCardRuleModelList: [],
        eachLaunchUpperLimit: "",
        eachHelpUpperLimit: "",
        automateBeTeam: "no",
        launchTimeType: "gameEnd",
        customTimeNum: "",
        subStockType: "",
        showState: "no", //个人中心显示状态
        showTag: "", //显示标签
        quotaState: "no", //额度状态
        quotaNum: "", //额度
      },
      screening: "",
      bargainType: "people",
      rule: [
        {
          name: "",
          needHelpSum: "",
          eachLaunchUpperLimit: "",
          ruleNum: "",
        },
      ],
      threshold: {
        expressModeGroup: [],
      },
      rules: {
        visualJoinNum: [
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur",
          },
          {
            required: true,
            message: "请输入虚拟参与人数",
            trigger: "blur",
          },
        ],
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur",
          },
          {
            min: 2,
            max: 30,
            message: "长度在 2 到 30 个字符",
            trigger: "blur",
          },
        ],
        mainImgUrl: [
          {
            required: true,
            validator: patterndMainImgUrlFunc,
            trigger: "blur",
          },
        ],
        gameRuleRemark: [
          {
            required: true,
            message: "请输入活动规则说明",
            trigger: "blur",
          },
        ],
        showTag: [
          {
            required: true,
            message: "请输入显示标签",
            trigger: "blur",
          },
          { min: 1, max: 5, message: "长度在5个字符以内", trigger: "blur" },
        ],
        activityDate: {
          required: true,
          validator: actDate,
          trigger: "blur",
        },
        drawTypeList: [
          {
            required: true,
            validator: patterndDrawTypeListFunc,
            trigger: "blur",
          },
          {
            required: true,
            validator: patterndCouponListFunc,
            trigger: "blur",
          },
        ],
        subStockType: [
          {
            required: true,
            message: "请选择扣减库存限制",
            trigger: "blur",
          },
        ],
        launchTimeType: [
          {
            required: true,
            validator: patterndLaunchTimeTypeFunc,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            validator: wordArrFunc,
            trigger: "blur",
          },
        ],
        joinLimitMode: [
          {
            required: true,
            validator: patterndRawTypeFunc,
            trigger: "change",
          },
        ],
      },

      options: [
        {
          value: "1",
          label: "1",
        },
      ],
      CouponRules: [], //券规则
      actDesc: {},
      sole: Boolean,
      isCollapse: true,
      total: 0,
      couponList: [],
      currentPage: 1,
      pageSize: 10,
      selectedCoupons: [],
      currentRow: {},
      queryTypeDisabled:false,
      queryTypeDisabledEidt:true,
      isreturn:true,
    };
  },
  computed: mapGetters(["storeStyle", "microShopStoreList", "virtualGoods"]),
  watch: {
    "ruleForm.joinLimitMode": {
      handler(val) {
        if (val === "total") {
          this.ruleForm.joinNum2 = "";
          console.log("total");
        } else {
          this.ruleForm.joinNum = "";
          console.log("day");
        }
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.queryCouponList();
    this.calcHeight();
    this.$store.dispatch("queryStoreStyle");
    this.activityDetail().then(res => {
        console.log("res:",res.result);  
        let result = res.result;
        // this.ruleForm = result;
        this.ruleForm.gameName = result.gameName;
        this.ruleForm.gameType = result.gameType;
        this.ruleForm.gameBgp = result.gameBgp;
        this.ruleForm.gameRuleRemark = result.gameRuleRemark;
        this.ruleForm.activityDate = [
            result.gameStartTime,
            result.gameEndTime
        ];
        this.ruleForm.wordArr = result.passwordRuleModel.wordArr.split(',');
        this.ruleForm.passwordRuleModel.prizeList = result.passwordRuleModel.prizeList;
        this.ruleForm.passwordRuleModel.prizeList.map(v=>{
          v.isEdit = true;
        })
        this.ruleForm.joinLimitMode = result.passwordRuleModel.joinLimitMode;
        if(result.passwordRuleModel.joinLimitMode==='total'){
            this.ruleForm.joinNum = result.passwordRuleModel.joinNum;
        }else{
            this.ruleForm.joinNum2 = result.passwordRuleModel.joinNum;
        }
    })
    if (this.$route.query.type == "details") {
        this.queryTypeDisabled = true;
    }else{
        this.queryTypeDisabled = true;
        this.queryTypeDisabledEidt = false;
    }
  },
  destroyed: function () {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    activityDetail() {
      const { gameId } = this.$route.query;
      const params = {
        gameId
      };
      return this.$store.dispatch("queryActivitDetail", params);
    },  
    couponListChange(row) {
      console.log("couponListChange", row);
      this.couponList.forEach((v) => {
        if (v.couponSendId === row.couponSendId) {
          row.couponSendName = v.name;
          row.sendNumLimite = v.send_num;
        }
      });
    },
    addPassword() {
      if (!this.ruleForm.password) {
        this.$message({
          message: " 请输入口令",
          type: "warning",
        });
        return false;
      } else {
        this.ruleForm.wordArr.push(this.ruleForm.password);
        this.ruleForm.password = "";
      }
    },
    deletePassword(index) {
      this.ruleForm.wordArr.splice(index, 1);
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品货号", "商品条码"];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "导入模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.ruleForm.gameBgp = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toggleShow() {
      this.show = !this.show;
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else {
            this.currentStep = i - 1 <= 0 ? 1 : i - 1;
          }
        }
      });
    },
    addChild() {
      this.batchSetting();
    },
    deleteChild(index) {
      if (this.rule.length <= 1) {
        this.rule = [];
        this.addChild();
        return;
      }
      this.rule.splice(index, 1);
    },
    submitEditForm(formName) {
      let params;  
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          this.ruleForm.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          this.ruleForm.passwordRuleModel.joinLimitMode =
            this.ruleForm.joinLimitMode;
          if (this.ruleForm.passwordRuleModel.joinLimitMode === "total") {
            this.ruleForm.passwordRuleModel.joinNum = this.ruleForm.joinNum;
          } else {
            this.ruleForm.passwordRuleModel.joinNum = this.ruleForm.joinNum2;
          }
          if (this.ruleForm.wordArr.length) {
            this.ruleForm.passwordRuleModel.wordArr =
              this.ruleForm.wordArr.toString();
          } else {
            this.$message({
              message: " 请输入口令",
              type: "warning",
            });
            return false;
          }
          if (this.ruleForm.passwordRuleModel.prizeList.length) {
            this.ruleForm.passwordRuleModel.prizeList.forEach((v) => {
              console.log("v.sendNum",v.sendNum);
              console.log("v.sendNumLimite",v.sendNumLimite);
              if(!v.couponSendId){
                this.$message({
                  message: "请选择优惠券",
                  type: "warning",
                });
                this.isreturn = false;
              }else if(!v.sendNum){
                this.$message({
                  message: "请输入数量",
                  type: "warning",
                });
                this.isreturn = false;
              }else if (v.sendNum > v.sendNumLimite) {
                this.$message({
                  message: "口令红包奖励数量不能超过最大数量",
                  type: "warning",
                });
                this.isreturn = false;
              }else{
                this.isreturn = true;
              }
            });
          } else {
            this.$message({
              message: "请新增奖励",
              type: "warning",
            });
            return false;
          }
          if(!this.isreturn){
             return false;
          }
          console.log("this.ruleForm", this.ruleForm);
          params = {
            gameId: this.$route.query.gameId,
            gameName: this.ruleForm.gameName,
            gameType: this.ruleForm.gameType,
            gameBgp: this.ruleForm.gameBgp,
            gameRuleRemark: this.ruleForm.gameRuleRemark,
            gameStartTime: this.ruleForm.gameStartTime,
            gameEndTime: this.ruleForm.gameEndTime,
            passwordRuleModel: this.ruleForm.passwordRuleModel,
          };
          console.log("params", params);
          this.$store.dispatch("editActivity", params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
      
    },
    handleRemove() {
      this.ruleForm.gameBgp = "";
    },
    //查询优惠券
    queryCouponList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$store.dispatch("findCouponSendByEvent", params).then((res) => {
        if (res.code === "0") {
          this.couponList = res.result;
        }
      });
    },
    batchSetting() {
      let params = {
        couponSendId: "",
        couponSendName: "",
        sendNum: "",
        isEdit:false,
      };
      this.ruleForm.passwordRuleModel.prizeList.push(params);
    },
    deleteAppend(index) {
      this.ruleForm.passwordRuleModel.prizeList.splice(index, 1);
    },
  },
};
</script>
<style lang="scss">
.add-goods-containers {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .step-wrapper {
    border-bottom: 1px solid #ddd;
  }

  .btn {
    margin-left: 10px;

    .hmicon {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.timeListItem {
  .text {
    width: 376px;
    height: 20px;
    border: 1px solid #dddddd;
    border-radius: 4px;
    padding: 6px 12px;
    line-height: 20px;
    display: inline-block;
  }
}
.fixed-but {
  position: fixed;
  top: 150px;
  right: 20px;
}

.pvw {
  .pvws {
    border: 1px solid #d9d9d9;
    width: 350px;
    margin-right: 100px;
    position: relative;
    position: fixed;
    right: 0;

    .commodityImg {
      width: 150px;
      height: 100px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .actcontent {
      width: 161px;
      height: 100px;
      margin-left: 20px;

      .activityTitle {
        font-size: 18px;
        font-weight: 600;
        margin-top: -1px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 2; //显示的行
      }

      .activityPrice {
        font-size: 24px;
        color: #ff563a;
        font-weight: 600;
      }

      .originalCost {
        color: #919191;
      }
    }

    .hr {
      height: 10px;
      background-color: #f7f7f7;
    }

    .pvwimg {
      width: 100%;
      height: 100%;
      // position: relative;
    }

    .describe {
      width: 100%;
      color: #ffffff;
      font-size: 17px;
      position: absolute;
      left: 50%;
      margin-left: -50%;
      top: 248px;
    }
  }

  #audio_btn {
    position: absolute;
    left: 10px;
    top: 70px;
    z-index: 999999;
    width: 45px;
    height: 45px;
    background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/ico_music.png");
    background-size: contain;
    background-repeat: no-repeat;
  }

  .rotate {
    -webkit-animation: rotating 1.2s linear infinite;
    -moz-animation: rotating 1.2s linear infinite;
    -o-animation: rotating 1.2s linear infinite;
    animation: rotating 1.2s linear infinite;
  }
}

.table {
  border: 1px solid #ddd;

  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }

  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }

  .table-row:nth-child(even) {
    background: #f7f7f7;
  }

  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}

.priview {
  position: relative;
  width: 400px;
  height: 712px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;

  img {
    width: 100%;
    height: 100%;
  }

  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;

  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }

  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }

  .slot {
    .header-img-wrapper {
      box-sizing: border-box;

      .header-img {
        width: 100%;
        display: block;
      }
    }

    .empty {
      margin-top: 30px;
      text-align: center;
    }

    strong {
      font-size: 16px;
    }

    .preview-goods-list {
      padding: 15px;
      font-size: 12px;

      &:hover {
        .add-goods {
          display: block;
          position: absolute;
          cursor: pointer;
          display: none;
          top: 0;
          left: 0;
          z-index: 9030;
          zoom: 1;
          width: 34px;
          height: 34px;
          font-size: 12px;
          background-color: rgba(0, 0, 0, 0.8);
          border: 1px solid #fff;
          border-radius: 4px;
          text-align: center;
          line-height: 34px;
        }
      }

      .add-goods {
        position: absolute;
        top: 0;
        left: 0;
        display: none;
      }

      .coupon-item {
        position: relative;
        &:hover {
          .delete-item {
            display: block;
          }
        }

        .goods-head {
          border-radius: 20px;
          background-color: #ffc1c1;
          padding: 10px;
          margin-bottom: 10px;
          .head-ms {
            padding: 10px 5px;
            width: 75%;
            .ms {
              font-size: 16px;
              color: #f72b2b;
              margin-bottom: 20px;
              font-weight: bold;
            }
            .rule-bq {
              padding: 0px 4px;

              height: 25px;
              text-align: center;
              line-height: 25px;
              background: rgba(255, 255, 255, 0.46);
              border-radius: 18px;
              margin-right: 12px;
              font-size: 12px;
              color: #f72b2b;
            }
          }

          .head-btn {
            font-size: 16px;
            padding: 3px 5px 10px 5px;
            width: 25%;
            color: #f72b2b;
            font-weight: bold;
            .btn-wrapper {
              color: white;
              padding: 0px 6px;
              height: 38px;
              font-size: 14px;
              text-align: center;
              line-height: 38px;
              background: #f72b2b;
              border-radius: 24px;
            }
          }
        }

        .goods-item {
          background: #fff;
          margin-bottom: 10px;
          padding: 10px;
          border-radius: 5px;

          .rule-wrapper {
            width: 30%;
            padding: 0px 10px;
            font-size: 18px;
            color: #f72b2b;

            .rule-money {
              font-size: 48px;
            }
          }

          .goods-name {
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 10px;
          }

          .tag {
            font-size: 12px;
            padding: 0 5px;
            color: #fff;
            border-radius: 30px;
          }

          .origin-price {
            color: #999;
            margin-top: 8px;
            text-decoration: line-through;
          }
        }
      }
    }
  }

  .progress-wrapper {
    margin-bottom: 5px;

    .progress {
      position: relative;
      width: 134px;
      border-radius: 30px;
      overflow: hidden;
      height: 13px;
      line-height: 13px;

      .slide {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        height: 100%;
        border-radius: 30px;
      }
    }

    .percent {
      font-size: 12px;
      margin-left: 10px;
    }
  }
}

.font-ms {
  font-size: 14px;
  color: #666666;
}
</style>
